import {useState, useEffect, useContext} from "react";
import {ListSubheader, MenuItem} from "@material-ui/core"
import TabPanel from "../request-emails/TabPanel"
import Index from "./Index"
import ShowBill from "./bill/ShowBill"
import TextractContext from "../../contexts/TextractContext"
import TextractAppBar from "./TextractAppBar";
import TextractSnackbar from "./snackbar/TextractSnackbar";
import Configuration from "./configuration/Configuration"
import {Route} from "react-router-dom"
import {useHistory, useLocation, useParams, Switch} from 'react-router-dom'
import Mappings from "./mappings/Mappings"
import { seo } from "../helpers/seo";
import PromptNotes from "./prompts/PromptNotes"
import axiosAuth from "../../utils/axiosWithAuth";
import "./Textract.scss";
import useLocalStorage from "../../hooks/useLocalStorage";
import { parseQueryString } from "../helpers/string-helpers";
import ModeTabs from "./ModeTabs";
import Intake from "./intake/Intake";
import { IntakeAccountProvider } from "../../contexts/AccountContext";
import UserContext from "../../contexts/UserContext";
import Validation from "./validation/Validation"
import AuthorizationIndex from "./authorizations/AuthorizationIndex";
import Authorization from "./authorizations/Authorization";
import SchemaEditor from "./schemas/SchemaEditor";

const CLIENTS = [{
  name: "EnergyPrint, Inc.",
  id: 11
},{
  name: "Highland Fleets",
  id: 2781
},{
//   name: "Tango Analytics",
//   id: 2780
// },{
//   name: "Enertiv",
//   id: 2802
// },{
  name: "Alpha ACS",
  id: 2806
},{
//   name: "Ruyle Corporation",
//   id: 2805
// },{
//   name: "EnvironmentalSAVE",
//   id: 2693
// },{
  name: "Demo Company",
  id: 2351
},{
//   name: "Utility Management Services",
//   id: 2822
// },{
  name: "Marvin Windows (Disposal)",
  id: 2286
}, {
  name: "Forefront Power",
  id: 2866
},
]

const getInitialTabIndex = (pathname, user) => {
  
  if (pathname.includes("/authorizations")) {
    return 0
  } 

  if (pathname.includes("/review")) {
    if (user.admin) {
      return 3
    }
    return 2
  } 

  if (user.admin) {
    return 2
  } 
  
  return 1
}


export default function TextractContainer() {
  const history = useHistory()
  const location = useLocation();
  const CONFIGURATION_BASE = {
    name: "Loading...",
    queries: [],
    ai_model: "gpt-5-mini-high",
    use_forms: false,
    use_tables: false,
    use_queries: true,
    use_expense: false,
    no_lighting_usage: false,
    storm_water_always_one_esu: true,
    provides_sewer_usage: false,
    gets_usage_from_queries: false,
    schema_id: null
  }
  const {user} = useContext(UserContext)
  const [fetchNew, setFetchNew] = useState(false)
  const [utilityCompanies, setUtilityCompanies] = useState([])
  const [accounts, setAccounts] = useState([])
  const [uams, setUams] = useState([])
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [selectedUtilityCompany, setSelectedUtilityCompany] = useState(null)
  const [loadingQueue, setLoadingQueue] = useState(false)
  const [tabIndex, setTabIndex] = useState(1)
  const [textractBills, setTextractBills] = useState([])
  const [configurations, setConfigurations] = useState([])
  const [selectedTextractBill, setSelectedTextractBill] = useState(null)
  const [selectedConfiguration, setSelectedConfiguration] = useState(CONFIGURATION_BASE)
  const [selectedTextractBillId, setSelectedTextractBillId] = useState(null)
  const [groupedConfigurations, setGroupedConfigurations] = useState([<ListSubheader>Loading...</ListSubheader>])
  const [currentScaffold, setCurrentScaffold] = useState(null)
  const [dateRange, setDateRange] = useState({})
  const [modeTabIndex, setModeTabIndex] = useState(getInitialTabIndex(location.pathname, user))
  const [snackbar, setSnackbar] = useState({
    message: "",
    severity: "success"
  })


  const [filters, setFilters] = useLocalStorage('invoyageFilters',{
    status: "ALL",
    page: 0,
    rowsPerPage: 25,
    sort: 'tb.id',
    order: 'desc',
    query: "",
    utility_company_id: "all",
    delivery_id: "All",
    processed_by_user_id: "all",
    company_id: user.company_id
  }, parseQueryString())

  const deselectBill = _ => {
    setSelectedTextractBillId(null)
    setSelectedTextractBill(null)
    history.push(process.env.REACT_APP_MODE != "invoiage" ? "/invoiage" : "/documents")
  }
  
  useEffect(() => {
    if (!user) return
    const subrouteRegex = /\/(authorizations|review)/
    let [basePath, id] = location.pathname.split(subrouteRegex).map(str => str.replace(/\/+$/, '')); // Get the base path (e.g., /invoiage or /documents)
    if (!basePath || basePath === '/') {
      basePath = '/documents';
    } else {
      // Remove any trailing ID (e.g., /documents/8600 -> /documents)
      basePath = basePath.replace(/\/\d+$/, '');
    }
  
    console.log('basePath:', basePath, 'id:', id);
  
    if (modeTabIndex === 0) {
      if (!location.pathname.includes('/authorizations')) {
        history.push(`${basePath}/authorizations${id ? '/' + id : ''}`);
      }
    } else if (modeTabIndex === 2 && !user.admin) {
      if (!location.pathname.includes('/review')) {
        history.push(`${basePath}/review${id ? '/' + id : ''}`);
      }
    } else {
      if (subrouteRegex.test(location.pathname)) {
        history.push(basePath);
      }
    }
  }, [modeTabIndex, location.pathname, history]);


  const fetchConfigurationById = (configId) => {
    axiosAuth().get(`${user.admin ? "admin/textract_configurations" : "documents/configurations"}/${configId}`).then(response => {
      setSelectedConfiguration(response.data.configuration)
    })
  }


  useEffect(_ => {
    console.log("Hello from TextractContainer.js")
    seo({
      title: "Invoiage"
    })


    axiosAuth().get(`${user.admin ? "admin/textract_configurations" : "documents/configurations"}`)
    .then(r => {
      setConfigurations(r.data.configurations)

      fetchConfigurationById(r.data.configurations[0].id);
    }).catch(console.error)
    console.log("Fetching Utility companies....")
    axiosAuth().get(`/utility_companies`)
    .then(r => {
      setUtilityCompanies(r.data)
    })
    .catch(err => console.error(err.response))

    axiosAuth().get(user.admin ? "/admin/textract_bills" : "/documents/search")
    .then(r => {
      setTextractBills(r.data.textractBills)
    })
    .catch(console.error)
  }, [])

  useEffect(_ => {
      const h = {Metadata: [], Utilities: [], Unmapped: []}
      configurations.forEach((t) => t.name == "Invoice Metadata" 
                                    ? h.Metadata.push(t) 
                                    : t.utility_company_id 
                                      ? h.Utilities.push(t)
                                      : h.Unmapped.push(t))
      const configSelect = []
      Object.keys(h).forEach(key => {
          configSelect.push(<ListSubheader style={{fontSize: "1.25rem"}}>{key}</ListSubheader>)
          h[key].sort((a,b) => a.name.localeCompare(b.name)).forEach(config => {
              configSelect.push(<MenuItem key={"config-" + config.id} value={config.id}>{config.name}</MenuItem>)
          })
      })
      setGroupedConfigurations(configSelect)
  }, [configurations])

  useEffect(_ => {
    if (!selectedTextractBillId) {
      setSelectedTextractBill(null)
      return
    }

  }, [selectedTextractBillId])

  useEffect(_ => {
    if (selectedTextractBill && selectedTextractBill.utility_company_id) {
      const foundConfig = configurations.find(config => config.utility_company_id == selectedTextractBill.utility_company_id)
      if (foundConfig) {
        fetchConfigurationById(foundConfig.id)
      }
    }

  }, [selectedTextractBill])

  const tabContent = [
    {
      index: 0,
      component: (
        <Switch>
          <Route
            exact
            path="/invoiage/authorizations"
            component={AuthorizationIndex}
          />
          <Route
            path="/invoiage/authorizations/:id"
            component={Authorization}
          />
          <Route
            exact
            path="/documents/authorizations"
            component={AuthorizationIndex}
          />
          <Route
            path="/documents/authorizations/:id"
            component={Authorization}
          />
        </Switch>
      ),
    },
    ...(user.admin
      ? [
          {
            index: 1,
            component: (
              <IntakeAccountProvider>
                <Intake />
              </IntakeAccountProvider>
            ),
          },
        ]
      : []),
    {
      index: user.admin ? 2 : 1,
      component: (
        <>
          <TextractAppBar />
          <TabPanel value={tabIndex} index={0}>
            <Configuration />
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <Switch>
              <Route exact path="/invoiage" component={Index} />
              <Route path="/invoiage/:id" component={ShowBill} />
              <Route exact path="/documents" component={Index} />
              <Route path="/documents/:id" component={ShowBill} />
            </Switch>
          </TabPanel>
          <TabPanel value={tabIndex} index={2}>
            <Mappings />
          </TabPanel>
          <TabPanel value={tabIndex} index={3}>
            <PromptNotes />
          </TabPanel>
          {/* <TabPanel value={tabIndex} index={4}>
            <SchemaEditor />
          </TabPanel> */}
        </>
          ),
    },
    {
      index: user.admin ? 3 : 2,
      component: <Validation />,
    },
  ];

  // Reset modeTabIndex when user.admin changes to avoid invalid indices
  useEffect(() => {
    const maxIndex = user.admin ? 3 : 2; // Max index based on number of tabs
    if (modeTabIndex > maxIndex) {
      setModeTabIndex(0); // Reset to "Authorizations" if index is out of bounds
    }
  }, [modeTabIndex, setModeTabIndex]);

  useEffect(_ => {
    if (user.admin) {
      if (modeTabIndex == 1) setModeTabIndex(getInitialTabIndex(location.pathname, user))
      setTabIndex(1)
    } else {
      setTabIndex(1)
    }
  }, [user.admin])

  
  return (
    <TextractContext.Provider value={{CLIENTS, dateRange, setDateRange, currentScaffold, setCurrentScaffold, loadingQueue, setLoadingQueue, groupedConfigurations, fetchNew, setFetchNew, uams, setUams, utilityCompanies, setUtilityCompanies, accounts, setAccounts, selectedAccount, setSelectedAccount, selectedUtilityCompany, setSelectedUtilityCompany, filters, setFilters, deselectBill, CONFIGURATION_BASE, configurations, setConfigurations, tabIndex, setTabIndex, selectedConfiguration, setSelectedConfiguration, textractBills, setTextractBills, selectedTextractBill, setSelectedTextractBill, selectedTextractBillId, setSelectedTextractBillId, snackbar, setSnackbar}}>
      <>
        <ModeTabs index={modeTabIndex} setIndex={setModeTabIndex} />
        {tabContent.map((tab) => (
          <TabPanel
            key={tab.index}
            boxPadding={0}
            value={modeTabIndex}
            index={tab.index}
          >
            {tab.component}
          </TabPanel>
        ))}
        <TextractSnackbar 
          snackbar={snackbar}
          setSnackbar={setSnackbar}
        />
      </>
    </TextractContext.Provider>
    
  )
}
